/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { PropsWithChildren, ReactElement, useCallback, useState } from 'react'
import AdminHeader from '../nav/AdminHeader'
import AdminNavbar from '../sidebar/AdminNavbar'
import { AppShell, AppShellProps, Box, Burger, Group, Text } from '@mantine/core'
import AppLogo from '../AppLogo'
import { getAppName, getAppVersion } from '../../lib/app'
import { Outlet } from 'react-router-dom'
import AuthExpiredModal from '../../../../modules/auth/components/AuthExpiredModal'
import VersionNotesNotifier from '../../../../modules/twh/components/version/VersionNotesNotifier'

export type AdminLayoutProps = PropsWithChildren & AppShellProps & {
  headerContent?: ReactElement
}

function AdminLayout (props: AdminLayoutProps) {
  const {
    children,
    headerContent,
    ...others
  } = props

  // todo close sidebar by default on small device
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(true)

  const toggleNavbar = useCallback(() => {
    setSidebarOpen((s) => !s)
  }, [])

  return (
    <AppShell
      className="AdminLayout"
      header={{ height: 60 }}
      navbar={{
        breakpoint: 'sm',
        width: 300,
        collapsed: {
          desktop: !sidebarOpen,
          mobile: !sidebarOpen
        }
      }}
      padding="md"
      {...others}
    >
      <AppShell.Navbar>
        <AdminNavbar />
      </AppShell.Navbar>

      <AppShell.Header>
        <AdminHeader>
          <Burger
            opened={sidebarOpen}
            onClick={toggleNavbar}
            size="sm"
          />
          <AppLogo h={40} w={40} />
          <Box>
            <Text>{getAppName()}</Text>
            <Text size="xs">{`v${getAppVersion()}`}</Text>
          </Box>
          <Group ml="sm">
            {headerContent}
          </Group>
        </AdminHeader>
      </AppShell.Header>

      <AppShell.Main pos="relative">
        <Outlet />
        {children}

        <VersionNotesNotifier />
        <AuthExpiredModal />
      </AppShell.Main>
    </AppShell>
  )
}

export default AdminLayout
